export enum MaterialEditorEntryMode {
    Edit = "Edit",
    Setup = "Setup",
}
